import { Form, FormTheme } from '@kanda-libs/ks-component-ts';
import { Button, Loader } from '@kanda-libs/ks-design-library';
import FileDrop from 'components/form/FileDrop';
import { CLASS_NAMES } from './constants';
import useEnquiryQuoteUploadQuoteForm from './useEnquiryQuoteUploadQuoteForm';

const EnquiryQuoteUploadQuote: React.FunctionComponent = function () {
  const { form, onSubmit, isSubmitting } = useEnquiryQuoteUploadQuoteForm();
  return (
    <Form id="enquiry-quote-upload-quote" form={form} onSubmit={onSubmit}>
      <FormTheme variant="streamline">
        <div className="flex flex-col mt-2">
          <h1 className={CLASS_NAMES.header}>Select your quote</h1>
          <h3 className={CLASS_NAMES.subheader}>
            Select the quote from us that you would like to apply for finance
            for. Once you click submit, Ideal4Finance will extract the relevant
            information from the quote and ask you to confirm the details
          </h3>
          <FileDrop name="document" isSubmitting={isSubmitting} />
          <Button.Text
            id="enquiry-quote-upload-quote-submit"
            submit
            label="Next"
            variant="gradient"
            className="mt-10"
            disabled={isSubmitting}
          />
          <Loader isLoading={isSubmitting} />
        </div>
      </FormTheme>
    </Form>
  );
};

export default EnquiryQuoteUploadQuote;
